// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ButtonComponent } from '@lbca-shared/button';
import { IconComponent } from '@lbca-shared/icon';
import { v1 as uuidV1 } from 'uuid';
import { ASSETS } from '../../../assets/assets';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../helpers/_old_helpers/overlayHelperClass';

@Component({
  selector: 'lbca-search-box',
  templateUrl: './search-box.component.html',
  styleUrl: './search-box.component.scss',
  imports: [IconComponent, CdkPortal, ButtonComponent],
})
export class SearchBoxComponent implements AfterViewInit, OnInit {
  readonly assets = inject(ASSETS);
  private optionsOverlay: OverlayHelper;
  public placeHolder: string = '';
  public isDisabled: boolean = false;
  private timeOut: any = null;

  public modesOperator: 'simple' | 'tag' = 'simple';
  public optionsList: any[] = [];
  private filterQuery!: any;
  public tagOpen: any = null;
  private recover: any[] = [];
  public isFocused = false;
  @ViewChild('inputSearch', { static: true }) input!: ElementRef;
  @ViewChild('templateTags', { static: true }) templateTags!: TemplatePortal;
  @Output('searchValue')
  searchValueEmmiter = new EventEmitter();
  @Output('clear')
  clearEmmiter = new EventEmitter();
  @Output('clearSearchFunction')
  clearSearchByMenuEmmiter = new EventEmitter();
  public tagList: any[] = [];
  @Input('tagList') set setterTagList(val: any) {
    this.tagList =
      typeof val === 'string'
        ? [
            {
              value: val,
              type: 'general',
              key: uuidV1() + '_general',
              label: 'geral',
            },
          ]
        : val;
  }
  @Input('disabled')
  set inputDisabled(val: boolean) {
    this.isDisabled = val;
  }
  @Input('clearDataSearch')
  set clearDtSearch($event) {
    this.input.nativeElement.value = '';
    this.clearEmmiter.emit();
  }
  @Input('placeholder')
  set placeHolderMessage(msg: string) {
    if (msg) this.placeHolder = msg;
  }
  @Input('queryOptions')
  set options(list: Array<any>) {
    if (list.length) {
      this.modesOperator = 'tag';
      this.optionsList = list;
    }
  }
  @Input() shouldFocused = false;
  constructor() {
    const overlay = inject(Overlay);

    this.optionsOverlay = new OverlayHelper(overlay);
  }
  ngOnInit(): void {
    this.placeHolder = this.assets.labels.components.fields['search-default-placeholder'];
    this.clearSearchByMenuEmmiter.emit(this.clearSearchByMenu);
    if (this.shouldFocused) {
      this.input.nativeElement.focus();
    }
  }
  ngAfterViewInit(): void {
    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      connectedTo: this.input,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };
    this.optionsOverlay.setConfiguration(config);
  }
  public clearSearchByMenu = () => {
    if (this.isDisabled) return;
    this.input.nativeElement.value = '';
    this.tagOpen = null;
    this.tagList = [];
  };
  public clearSearch($event): void {
    $event.stopPropagation();
    if (this.isDisabled) return;
    this.input.nativeElement.value = '';
    this.input.nativeElement.focus();
    this.tagOpen = null;
    if (this.tagList.length !== 0) {
      this.tagList = [];
      this.clearEmmiter.emit();
    }
  }
  lastObjectValue = '';
  private dataSend() {
    const objectValue = this.input.nativeElement.value;
    if (objectValue === '' || !this.tagOpen) return;
    this.input.nativeElement.value = '';
    const finalObj = {
      value: objectValue,
      type: this.tagOpen.type,
      key: this.tagOpen.key,
      label: this.tagOpen.label,
      join: this.tagOpen.join,
      redirect: this.tagOpen.redirect,
    };
    if (this.recover.length > 0) {
      const list: any[] = [];
      this.recover.forEach((item) => {
        if (item.key === this.tagOpen.key) {
          item.value = finalObj.value;
          item.type = finalObj.type;
          item.key = finalObj.key;
          item.label = finalObj.label;
          item.searchWithExactValue = finalObj.label;
          item.join = finalObj.join;
          item.redirect = finalObj.redirect;
        }
        list.push(item as any);
      });
      this.tagList = list;
    } else {
      this.tagList.push({
        value: objectValue,
        type: this.tagOpen.type,
        key: this.tagOpen.key,
        label: this.tagOpen.label,
        searchWithExactValue: this.tagOpen.searchWithExactValue,
        join: this.tagOpen.join,
        redirect: this.tagOpen.redirect,
      });
    }
    this.sendSearchValue();
    this.tagOpen = null;
    if (this.isFocused) {
      // this.showOverlay();
    }
  }
  public setInputValue($event): void {
    if (!this.input?.nativeElement?.value.trim()) return;
    if (!this.input.nativeElement.value && $event.key !== 'Backspace') return;
    if (this.modesOperator === 'simple') {
      this.filterQuery = this.input.nativeElement.value;
      if ($event.key === 'Enter' && this.filterQuery !== '') {
        this.dataSendGeneral();
        // this.dataSend();
        // //if (this.timeOut) clearTimeout(this.timeOut);
        // this.sendSearchValue();
      }
      if (this.isDisabled) return;
      // if(this.timeOut) clearTimeout(this.timeOut);
      // this.timeOut = setTimeout(()=> {
      //   return this.sendSearchValue()}, 10000);
    } else {
      if (this.tagOpen) {
        const objectValue = this.input.nativeElement.value;
        if (objectValue === '' && $event.key === 'Backspace' && this.lastObjectValue === '') {
          this.tagOpen = null;
        }
        this.lastObjectValue = this.input.nativeElement.value;
        if ($event.key === 'Enter' && objectValue !== '') {
          this.dataSend();
          this.optionsOverlay.close();
        }

        //if (objectValue !== '') {
        //  if (this.timeOut) clearTimeout(this.timeOut);
        //  this.timeOut = setTimeout(() => this.dataSend(), 3000);
        //}
      } else {
        const objectValue = this.input.nativeElement.value;
        // if (objectValue === '') this.showOverlay();
        // else this.optionsOverlay.close();
        if (objectValue === '' && $event.key === 'Backspace' && this.lastObjectValue === '') {
          this.removeLastTag();
        }
        this.lastObjectValue = this.input.nativeElement.value;
        if ($event.key === 'Enter') {
          this.dataSendGeneral();
        }
      }
    }
  }
  private dataSendGeneral() {
    const objectValue = this.input.nativeElement.value;
    if (objectValue === '') return;
    this.input.nativeElement.value = '';
    const id = uuidV1();
    this.tagList.push({
      value: objectValue,
      type: 'general',
      key: id + '_general',
      label: 'geral',
    });
    if (this.isFocused) {
      // this.showOverlay();
    }
    this.sendSearchValue();
  }
  private sendSearchValue(): void {
    // const payload = this.modesOperator === "simple"
    //   ? this.filterQuery
    //   : this.tagList

    const payload = this.tagList;

    this.tagList.push();
    if (this.modesOperator === 'simple' && !payload) this.tagList = [];
    this.searchValueEmmiter.emit(payload);
    if (this.modesOperator === 'simple') {
      this.input.nativeElement.value = '';
    }
  }
  public setFocus(foco) {
    this.isFocused = foco;
    if (foco && !this.tagOpen) {
      // this.showOverlay();
    }
    //Limpar tag aberta quando clicar fora da barra de pesquisa
    else {
      this.input.nativeElement.value = '';
      this.tagOpen = null;
      this.optionsOverlay.close();
    }
    if (!foco && !this.tagOpen && this.modesOperator !== 'simple') {
      this.dataSendGeneral();
    }
  }
  public selectTag($event, option) {
    $event.preventDefault();

    if (option?.redirect) {
      option.value = '';
      this.tagList.push(option);
      this.sendSearchValue();
    } else {
      this.tagOpen = option;
      this.recover = [];
      const index = this.tagList.findIndex((tag) => tag.key === this.tagOpen.key);
      if (index > -1) {
        this.recover = this.tagList;
      }
      const lastTag = this.tagList.find((tag) => tag.key === this.tagOpen.key);
      if (lastTag) {
        this.tagList = this.tagList.filter((tag) => tag.key !== this.tagOpen.key);
        this.input.nativeElement.value = lastTag.value;
      }
    }
    this.optionsOverlay.close();
  }
  public removeTag(tag) {
    this.tagList = this.tagList.filter((tagElement) => tagElement.key !== tag.key);
    if (this.tagList.length === 0) {
      this.clearEmmiter.emit();
    } else {
      this.sendSearchValue();
    }
  }
  private removeLastTag() {
    this.tagList.splice(-1, 1);
    if (this.tagList.length === 0) {
      this.clearEmmiter.emit();
    } else {
      this.sendSearchValue();
    }
  }
  private showOverlay() {
    if (this.modesOperator === 'tag') {
      this.optionsOverlay.show(this.templateTags);
    }
  }
}
